import { Component, inject, OnInit } from '@angular/core';
import { NotificationsService } from '../../../../shared/services/notifications.service';
import { LoggerService } from '../../../../shared/services/logger.service';
import { ToastService } from '../../services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-received-authed',
  templateUrl: './payment-received-authed.page.html',
  styleUrls: ['./payment-received-authed.page.scss'],
  standalone: false,
})
export class PaymentReceivedAuthPage {
  notificationsService = inject(NotificationsService);
  loggerService = inject(LoggerService);
  toastService = inject(ToastService);
  translateService = inject(TranslateService);
  constructor() {}

  async ionViewDidEnter() {
    const isAllowed = await this.notificationsService.ensureNotificationsAllowed();

    if (!isAllowed) {
      this.toastService.info(this.translateService.instant('NOTIFICATIONS.NOT_ALLOWED'), 5000);
    }
  }
}
